
import Vue from 'vue';
import { msalInstance } from '@/msal.config';
import { MUTATIONS } from '@/store/mutations';
import { GETTERS } from '@/store/getters';

export default Vue.extend({
  data() {
    return {
      path: this.$route.path,
    };
  },

  methods: {
    close(): void {
      this.$router.push(this.$store.getters[GETTERS.GET_BOOKING_URL] || '/');
    },

    logout(): void {
      if (msalInstance.getAllAccounts().length > 0) {
        this.$store.commit(MUTATIONS.LOGOUT_FROM_MS);
        msalInstance.logoutRedirect({ account: msalInstance.getAllAccounts()[0] });
      } else {
        this.$store.commit(MUTATIONS.CLEAR_STATE);
        this.$router.push('/login');
      }
    },
  },

  created() {
    this.$watch(
      () => this.$route.path,
      () => {
        // React to route changes.
        this.path = this.$route.path;
      },
    );
  },

  computed: {
    showImage(): boolean {
      return this.path === '/login';
    },

    showClose(): boolean {
      return this.path.includes('/booking');
    },

    showLogout(): boolean {
      return this.path === '/';
    },
  },
});
